import { combineReducers } from 'redux';
import createSaga from './saga';
import sendMessageFormSaga from './sendMessagesForm/sendMessageFormSaga';
import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';
import { createReduceObject as sendMessagesFormReduceObject } from './sendMessagesForm/reducer';
import { reducerRegistry } from '../../../../../reducerRegistry';

export const createReducerName = name => `roomMessages/${name}`;

export function registryCombineReducer(reducerName) {
  const combine = combineReducers({
    ...createListReduceObject(reducerName, 'list'),
    ...sendMessagesFormReduceObject(reducerName, 'sendMessageForm')
  });
  reducerRegistry.register(reducerName, combine, [
    createSaga,
    sendMessageFormSaga
  ]);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/messenger/reducers/dynamic/roomMessages/combineRegistry.js